import type { PrimitiveKind } from "@/document/model/primitives";
import { oklchToHex } from "@/document/model/color";
import {
  createDefaultStyle,
  createSolidPaint,
  normalizeStrokeStack,
  type NodeStyle,
  type Paint,
  type StrokeStyle,
} from "@/document/model/styles";

export const DEFAULT_DRAWING_FILL = "#AAAAAA";
export const DEFAULT_DRAWING_STROKE = "#000000";

let lastSolidFill = DEFAULT_DRAWING_FILL;
let lastSolidStroke = DEFAULT_DRAWING_STROKE;

export function getLastSolidFill(): string {
  return lastSolidFill;
}

export function getLastSolidStroke(): string {
  return lastSolidStroke;
}

export function rememberSolidFill(paint: Paint): void {
  if (paint.type === "solid") {
    lastSolidFill = oklchToHex(paint.color);
  }
}

export function rememberSolidStroke(paint: Paint): void {
  if (paint.type === "solid") {
    lastSolidStroke = oklchToHex(paint.color);
  }
}

export function rememberSolidPaintsFromStyle(style: NodeStyle): void {
  const fill = style.fills.at(-1);
  const stroke = normalizeStrokeStack(style).at(-1);
  if (fill) {
    rememberSolidFill(fill);
  }
  if (stroke) {
    rememberSolidStroke(stroke.paint);
  }
}

export function primitiveDrawingStyle(kind: PrimitiveKind): NodeStyle {
  if (kind === "line") {
    return strokeOnlyDrawingStyle("inside");
  }

  return createDefaultStyle(lastSolidFill);
}

export function pathDrawingStyle(): NodeStyle {
  return strokeOnlyDrawingStyle("center");
}

function strokeOnlyDrawingStyle(align: StrokeStyle["align"]): NodeStyle {
  const stroke: StrokeStyle = {
    paint: createSolidPaint(lastSolidStroke),
    width: 1,
    align,
  };

  return {
    fills: [],
    strokes: [stroke],
    stroke,
    opacity: 1,
  };
}

export function resetDrawingStyleMemory(): void {
  lastSolidFill = DEFAULT_DRAWING_FILL;
  lastSolidStroke = DEFAULT_DRAWING_STROKE;
}
